<template>
    <okraina-view :class="'okraina-v-pcoupons'" ref="view" @refresh="refresh" :hideMenu="true"
        :contentHorizontalPadding="19">

        <template v-slot:header>
            <h1>
                Купоны в магазинах
            </h1>
        </template>

        <template v-slot:content>

            <div class="spacer"></div>

            <!--Индикатор загрузки-->
            <transition>
                <okraina-loader-page v-show="loading || !canShow" />
            </transition>

            <!-- Ошибка загрузки -->
            <template v-if="loadingError && !loadingCommon">

                <div class="text-center">
                    Ошибка загрузки данных.
                    <br /><br />
                    <div class="btn btn1" @click="retryLoad">Повторить</div>
                </div>

            </template>

            <template v-if="!loading && canShow">

                <div class="list">
                    <okraina-coupon-item v-for="item in items" :key="item.id" :item="item" @click="onItemClick(item)" />
                </div>

                <template v-if="items.length == 0">
                    Список пуст
                </template>

                <div ref="pager" class="pager"></div>

                <!-- Подгрузка следюущей страницы -->
                <template v-if="loadingPaging">
                    <div class="text-center">
                        <okraina-loader-inline />
                    </div>
                </template>


                <okraina-coupon-barcode v-model:visible="showBarcode" :number="barcode" />

            </template>


        </template>


    </okraina-view>


</template>

<script>
import okrainaView from "@/components/view2.vue"
import okrainaLoaderPage from "@/components/loader.page.vue";
import okrainaLoaderInline from "@/components/loader.inline.vue";
import okrainaCouponItem from "@/components/personal/coupon.item.vue";
import okrainaCouponBarcode from "@/components/personal/coupon.barcode.vue";

import rest from "@/plugins/rest";
import bus from "@/plugins/bus";
import moment from "moment";
import meta from "@/plugins/meta";
import metaTemplates from "@/plugins/meta/personal.coupons.js";

export default {
    name: "okraina-v-personal-coupons",
    components: {
        okrainaView,
        okrainaLoaderPage,
        okrainaLoaderInline,
        okrainaCouponItem,
        okrainaCouponBarcode
    },
    data() {
        return {
            loading: false,
            reload: false,
            loadingPaging: false,
            loadingCommon: false,
            loadingError: false,

            items: [],
            pager: {
                NUM_PAGE: 1,
                PAGE_SIZE: 20,
                PAGES_COUNT: 1,
            },
            canShow: false,

            showBarcode: false,
            barcode: "",
        };
    },

    methods: {

        /**
         * Загружает данные
        */
        loadData(resolve = false) {

            if (this.loadingCommon) {
                return;
            }
            this.loadingCommon = true;

            rest
                .call("bonus.coupon.getlist", {
                    method: "post",
                    data: {
                        NAV_PARAMS: this.pager
                    },
                })
                .then((data) => {
                    if (data.SUCCESS) {
                        if (this.pager.NUM_PAGE == 1) {
                            this.items = data.ITEMS;
                        } else {
                            this.items = this.items.concat(data.ITEMS);
                        }
                        this.pager = data.PAGER;
                    } else {
                        //показываем сообщение об ошибке
                        bus.emit("OKRAINA_MESSAGE_E_SHOW", { message: data.ERROR_TEXT });
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.loadingPaging = false;
                    this.loadingCommon = false;
                    this.reload = false;
                    if (resolve) {
                        resolve();
                    }
                });
        },

        /**
         * Повторная попытка загрузки
         */
        retryLoad() {
            if (this.pager.NUM_PAGE == 1) {
                this.loading = true;
            } else {
                this.loadingPaging = true;
            }

            this.loadData();
        },

        /**
         * Перезагрузка экрана
         */
        refresh(resolve) {
            this.reload = true;
            this.pager.NUM_PAGE = 1;
            this.loadData(resolve);
        },

        /**
        * Скрол экрана
        */
        onScroll(e) {
            let scroll = e.target.scrollTop;
            let height = e.target.offsetHeight;
            let offsetTop = this.$refs.pager.offsetTop;

            //если экран прокрутился до пейджера
            if (scroll + height > offsetTop) {
                //если экран не в стадии загрузки и есть следующие страницы
                if (
                    !this.loadingCommon &&
                    !this.loadingPaging &&
                    !this.reload &&
                    this.canShow &&
                    this.pager &&
                    this.pager.NUM_PAGE < this.pager.PAGES_COUNT
                ) {
                    this.pager.NUM_PAGE++;
                    this.loadingPaging = true;
                    this.loadData(() => { });
                }
            }
        },

        /**
         * Клик по купону
         */
        onItemClick(item) {
            this.showBarcode = true;
            this.barcode = item.numberfield
        }
    },

    /**
     * Обраотка переход входом на экран
     */
    beforeRouteEnter() {
        //запишем мета данные страницы
        meta.write(metaTemplates);
    },

    created() {

        this.loading = true;
        this.loadData();

        //задерживаем показ до завершения перехода на экран (чтобы анимация перехода без тормазов была)
        setTimeout(() => {
            this.canShow = true;
        }, 400);
    },
}
</script>

<style lang="scss"></style>